
import axiosServices from './request';

const AnalysisEngine = axiosServices('analysisengine');

export default {
  /** 进行分享的记录埋点 */
  shareTrack: AnalysisEngine('post', 'weChatRecor/shareTrack'),
  /** 获取7日扫码量最高的书籍列表 */
  get7DayList: AnalysisEngine('get', 'sevenDaysBookStatis/getList')
};
